module.exports = __webpack_public_path__ + "static/media/pin-controls-selected.1811c943.svg";